<template>
  <div class="mainRight pageContainer flexCloumn positionPage">
    <el-row v-if="companyInfo.check_status == 1 || (tableData && tableData.length > 0)" class="searchBar flexBetween"
      style="flex-wrap: wrap;width:100%">
      <el-button v-if="companyInfo.check_status == 1" type="primary" icon="el-icon-plus" @click="PublishJob"
        size="small ">发布职位</el-button>

      <el-button type="primary" icon="el-icon-view" @click="goZpqs" size="small ">招聘启事</el-button>

      <div class="flexEnd flex_1">
        <el-input placeholder="职位名称" v-model="searchForm.job_name" size="small" class="input-with-select"
          style="width:200px;margin-left: 10px" clearable></el-input>
        <el-cascader v-model="searchForm.job_type" :props="{ value: 'id', label: 'type_name' }" :options="options"
          size="small" style="width:200px;margin-left: 10px" clearable placeholder="职位类型"></el-cascader>
        <el-select v-model="searchForm.check_status" clearable placeholder="审核状态" size="small"
          style="width:130px;margin-left:10px">
          <el-option label="全部" value></el-option>
          <el-option label="审核中" :value="0"></el-option>
          <el-option label="审核通过" :value="1"></el-option>
          <el-option label="审核不通过" :value="2"></el-option>
          <el-option label="已关闭" :value="3"></el-option>
        </el-select>
        <el-button icon="el-icon-search" style="margin-left:10px" size="small" type="primary"
          @click="getList">搜索</el-button>
      </div>

    </el-row>

    <el-row class="flexCenter" style="width:100%;">
      <div v-if="companyInfo.check_status != 1" style="text-align: center; color:orangered;padding:15px;">
        <div v-if="companyInfo.check_status == 2">
          您的企业认证失败：{{ companyInfo.remarks }}
        </div>
        <div v-else>
          您的企业正在审核中，请耐心等待审核通过后即可发布岗位！
        </div>

      </div>
      <div v-else style="text-align: center; color:orangered;">
        <div v-if="tableData.length == 0" style="padding:15px;">您还没有发布职位~</div>
      </div>
    </el-row>

    <div class="flex_1" style="width:100%;overflow-y:auto;padding:0 15px">

      <ul class="list-items">


        <li class="list-item flexBetween" v-for="(p, idx) in tableData" :key="idx">


          <div class="list-content">
            <p :class="(p.check_status == 0 || p.check_status == 1) ? 'name' : 'name name1'"> {{ p.job_name }}
              <span v-if="p.check_status == 0" class="style0">审核中</span>
              <span v-if="p.check_status == 1" class="style1">审核通过</span>

              <el-tooltip class="item" effect="dark" :content="p.check_desc" placement="top-end">
                <span v-if="p.check_status == 2" class="style2">审核不通过</span>
              </el-tooltip>


              <span v-if="p.check_status == 3" class="style3">已关闭</span>
            </p>
            <div style="color:#909399;font-size:14px;">
              工作地区：<span>{{ p.cityName || CITY_DIC[p.city] || '-' }}</span>
              <el-divider v-if="pmid != 220" direction="vertical" />
              <span v-if="pmid != 220">经验：{{ gzjy[p.experience] ? gzjy[p.experience].param_desc : '-' }}</span>
            </div>
            <div style="color:#909399;font-size:14px;">
              <span>学历：{{ xlyqObj[p.eduaction] || '-' }}</span>
              <el-divider direction="vertical" />
              <span> 薪资：{{ xzfwObj[p.pay] || '-' }}</span>
            </div>
          </div>
          <div class="sendNum" @click="toResume(p)">
            <div v-if="p.toudi_num > 0 && (p.check_status == 1 || p.check_status == 3)" style="font-size:14px;">
              <span>{{ p.toudi_num }}</span>
              人投递简历
              <i class="el-icon-arrow-right" />
            </div>
          </div>
          <div class="createdTime">{{ p.create_date.split(" ")[0] }} 发布</div>


          <ul class="list-item-action felxStart">
            <li>
              <a @click="edit(p)" type="primary">编辑</a>
              <em v-if="p.check_status == 3 || p.check_status == 1" class="list-item-action-split"></em>
            </li>
            <li v-if="p.check_status == 3">
              <a @click="publish(p)" type="primary">发布</a>
              <em v-if="p.check_status == 1" class="list-item-action-split"></em>
            </li>
            <li v-if="p.check_status == 1">
              <a @click="close(p)" type="primary">关闭</a>
            </li>

          </ul>
        </li>
      </ul>

    </div>
    <el-pagination v-if="companyInfo.check_status == 1 || (tableData && tableData.length > 0)"
      @current-change="handlePageChange" @size-change="handleSizeChange" :current-page="page.current_page"
      :page-size="page.per_page" :total="page.count" layout="total, sizes,prev, pager, next"
      :page-sizes="[10, 20, 50, 100]" style="margin: 10px 0 0 15px;">
    </el-pagination>
    <addPosition v-if="dialogshow" :id="formData.id"></addPosition>
    <FloatWindow v-if="pmid == 210"></FloatWindow>

  </div>
</template>

<script>
import citys from "../../utils/arae_value.js";
import util from "@/utils/util";
import addPosition from "./com/addPosition.vue";
import FloatWindow from './com/FloatWindow'

export default {
  components: {
    addPosition,
    FloatWindow
  },
  data() {
    return {
      companyInfo: {
        check_status: 0
      },
      searchForm: {
        job_name: "",
        param_desc: "",
        job_type: ""
      },
      dialogshow: false,
      tableData: [],
      formData: {},
      qyxz: [],
      xzfw: [], xzfwObj: {},
      xlyq: [], xlyqObj: {},
      gzjy: [],
      wyyq: [],
      jsjyq: [],
      gwshzz: [],
      page: {
        count: 0,
        current_page: 1,
        per_page: 50,
        total_page: 0
      },
      options: [],
      pmid: window.pmid,
      CITY_DIC: []
    };
  },
  mounted() {
    let cityList = this.TreeToArrayFor(citys)
    let CITY_DIC = {}
    for (let i = 0, len = cityList.length; i < len; i++) {

      CITY_DIC[cityList[i].value] = cityList[i].label

    }
    this.CITY_DIC = CITY_DIC
    this.getComType().then(rr => {
      this.$http.post("/api/zp_job_type_tree", {}).then(res => {
        this.options = res.data.tree;
      });
      this.$http.post("/api/enterprise_info", {}).then(res => {
        this.companyInfo = res.data;
      });
      this.getList();
    });
  },
  methods: {
    /**
        * tree转数组，循环模式，每次增加循环的变量
        * 【注意：】只能使用for 循环，不能使用es6的迭代器
        * @param tree
        * @returns {{length}|*}
        * @constructor
        */
    TreeToArrayFor(tree) {
      if (!Array.isArray(tree) || !tree.length) throw new Error("请传入数组")
      for (let i = 0; i < tree.length; i++) {
        if (tree[i].children) {
          // 每次children有值，就把值合并到原始数据tree上去，增加原始tree，for 循环 的长度也会增加 依次处理...
          tree = tree.concat(tree[i].children)
        }
      }
      return tree
    },
    getComType() {
      return new Promise(resolve => {
        let salaryType = window.pmid == 220 ? 'SALARY_RANGE_ZP' : 'SALARY_RANGE'
        this.$http
          .post("/api/sys_param_list", {
            param_type:
              "'ENTER_INFO','" + salaryType + "','EDUACTION','EXPERIENCE','ENGLISH_LEVEL','COMPUTER_LEVEL','GWSHZT','PROFESSIONS'",
            used: 0
          })
          .then(res => {
            let qyxz = []; //企业性质
            let xzfw = [], xzfwObj = {}; //薪资类型
            let xlyq = [], xlyqObj = {}; //学历类型
            let gzjy = []; //工作经验
            let wyyq = []; //外语要求
            let jsjyq = []; //计算机要求
            let gwshzz = []; //计算机要求
            let professions = []; //计算机要求
            let fldy = []
            for (let item of res.data) {
              if (item.param_type == "ENTER_INFO") {
                qyxz.push(item);
              }
              if (item.param_type == salaryType) {
                if (item.param_value == 0) item.param_desc = '面议'
                xzfw.push(item);
                xzfwObj[item.param_value] = item.param_desc
              }
              if (item.param_type == "EDUACTION") {
                xlyq.push(item);
                xlyqObj[item.param_value] = item.param_desc
              }
              if (item.param_type == "EXPERIENCE") {
                gzjy.push(item);
              }
              if (item.param_type == "ENGLISH_LEVEL") {
                wyyq.push(item);
              }
              if (item.param_type == "COMPUTER_LEVEL") {
                jsjyq.push(item);
              }
              if (item.param_type == "GWSHZT") {
                gwshzz.push(item);
              }
              if (item.param_type == "PROFESSIONS") {
                professions.push(item);
              }
              if (item.param_type == 'FLDY') {
                fldy.push(item);
              }
            }
            this.qyxz = qyxz;
            this.xzfw = xzfw; this.xzfwObj = xzfwObj
            this.xlyq = xlyq; this.xlyqObj = xlyqObj
            this.gzjy = gzjy;
            this.wyyq = wyyq;
            this.jsjyq = jsjyq;
            this.gwshzz = gwshzz;
            this.professions = professions;
            this.fldys = fldy
            resolve();
          });
      });
    },
    PublishJob() {
      this.formData = {
        title: "职位添加",
        job_name: "",
        need_num: 1,
        job_type: null,
        city: "",
        word_addr: "",
        experience: null,
        eduaction: null,
        english_level: null,
        computer_level: null,
        profession: null,
        pay: null,
        job_desc: "",
        fldy_desc: null,
      };
      this.dialogshow = true;
    },
    goZpqs() {
      window.open("./#/zpqs/" + this.companyInfo.id, "_blank")
      //this.$router.push("/zpqs/"+this.companyInfo.id)
    },
    edit(row) {
      this.formData = { ...row };
      this.formData.fldy = this.formData.fldy ? this.formData.fldy.split(',').map(m => Number(m)) : []
      this.formData.title = "职位编辑";
      if (this.formData.start_time) {
        this.formData.publish_date_range = [this.formData.start_time, this.formData.end_time]
      }
      this.dialogshow = true;
    },
    getList() {
      const loading = this.$globalLoading()
      let data = {};
      data.this_enter_id = 1;
      data.check_status = this.searchForm.check_status;
      data.job_name = this.searchForm.job_name;
      data.param_desc = this.searchForm.param_desc;
      data.job_type = this.searchForm.job_type[
        this.searchForm.job_type.length - 1
      ];
      data.page = this.page.current_page;
      data.pagesize = this.page.per_page;
      // citys.map(a => {
      //   a.children && a.children.map(b => {
      //     delete b.children
      //   })
      // })
      this.$http.post("/api/zp_job_info_list", data).then(res => {
        if (res.data && res.data.data) {
          res.data.data.map(a => {
            // let obj = this.getParentId(citys, a.city);
            // a.cityName = obj ? obj.label : '';
            let areaNames = util.getParentAreaByValue(citys, a.city)
            if (areaNames && areaNames.length > 0) {
              a.cityName = areaNames.map(a => a.label).reverse().join('/');
            }
          });
        }
        this.tableData = res.data.data;
        this.page = res.data.page;
        loading.close()
      });
    },
    getParentId(list, iid) {
      if (list && list.length > 0) {
        for (let o of list) {
          if (o.value == iid) return o;
          const o_ = this.getParentId(o.children, iid);
          if (o_) return o_;
        }
      }
    },
    publish(row) {
      const loading = this.$globalLoading()
      this.$http
        .post("/api/zp_job_info_audit", {
          id: row.id,
          check_status: 0
        })
        .then(res => {
          this.$message({
            type: "success",
            message: `职位:${row.job_name} 发布成功!`
          });
          this.getList();
          loading.close()
        });
    },
    close(row) {
      const loading = this.$globalLoading()
      this.$http
        .post("/api/zp_job_info_audit", {
          id: row.id,
          check_status: 3
        })
        .then(res => {
          this.$message({
            type: "success",
            message: `职位:${row.job_name} 关闭成功!`
          });
          this.getList();
          loading.close()
        });
    },
    toResume(info) {
      this.$router.push("/sddjl?job_id=" + info.id);
    },
    handlePageChange(page) {
      this.page.current_page = page;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.current_page = 1;
      this.page.per_page = val;
      this.getList(1)
    },
  }
};
</script>

<style scoped lang="less">
.pageContainer {
  /deep/ .box-card {
    margin-bottom: 12px;
    padding: 24px 10px 24px 30px;
  }

  /deep/ .el-card__body {
    padding: 0px;
  }

}

.positionPage {

  ul,
  li {
    list-style: none;

    outline: none;
  }

  .list-items {
    width: 100%;
    margin: 5px 0 0 0;
    padding: 0;
    list-style: none;

    outline: none;

    .list-item {

      background-color: #fff;
      padding: 24px !important;
      border: 0;
      margin-bottom: 12px;
      outline: none;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);



      @media screen and (min-width: 750px) {
        .list-content {
          width: 50%;
        }
      }

      .list-content {
        .name1 {
          color: #909399 !important;
        }

        .name {
          font-size: 18px;
          margin-bottom: 8px;
          margin-top: 0;
          color: #303133;

          span {
            font-size: 14px;
            padding: 1px 5px;
            border-radius: 4px;
            border: 1px solid #303133;
            margin-left: 5px;
          }

          .style0 {
            color: #3378fa;
            border-color: #3378fa;
          }

          .style1 {
            color: #19c295;
            border-color: #19c295;
          }

          .style2 {
            color: #ef342e;
            border-color: #ef342e;
          }

          .style3 {
            color: #c0c4cc;
            border-color: #c0c4cc;
          }



        }
      }

      .sendNum {
        width: 140px;
        cursor: pointer;

        span {
          font-size: 18px;
        }
      }

      .createdTime {
        color: #909399;
        font-size: 14px;
      }

      .list-item-action {
        width: 90px;
        margin-left: 30px;
        margin-bottom: 0;
        text-align: right;
        -webkit-box-flex: 0;
        flex: 0 0 auto;
        padding: 0;
        font-size: 0;
        list-style: none;

        li:first-child {
          padding-left: 0;
        }

        li {
          position: relative;
          display: inline-block;
          padding: 0 8px;
          color: rgba(0, 0, 0, 0.45);
          font-size: 14px;
          line-height: 22px;
          text-align: center;
          cursor: pointer;
          outline: none;
          box-sizing: border-box;
        }

        a {
          color: #3378fa;
          -webkit-transition: all 0.3s;
          transition: all 0.3s;
          touch-action: manipulation;
          background-color: transparent;
          cursor: pointer;
          text-decoration: none;
          outline: none;
          font-size: 14px;

        }

        .list-item-action-split {
          position: absolute;
          top: 50%;
          right: 0;
          width: 1px;
          height: 14px;
          margin-top: -7px;
          background-color: #e8e8e8;
        }
      }
    }
  }
}
</style>